import { render } from "./CustomerReports.vue?vue&type=template&id=5f97e2da"
import script from "./CustomerReports.vue?vue&type=script&lang=js"
export * from "./CustomerReports.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__